export const ADMISSAO_ETAPAS = [
  { id: 1, label: 'Dados pessoais' },
  { id: 2, label: 'Contratuais' },
  { id: 3, label: 'Dependentes' },
  { id: 4, label: 'Formação' },
  { id: 5, label: 'Reservista' },
  { id: 6, label: 'Saúde' },
  { id: 7, label: 'Emergência' },
  { id: 8, label: 'Documentação' },
  { id: 9, label: 'Benefícios' },
  { id: 10, label: 'Revisão' },
] as const

export const UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
]

export const BANCOS = [
  '001 — Banco do Brasil',
  '033 — Santander',
  '077 — Banco Inter',
  '104 — Caixa',
  '237 — Bradesco',
  '260 — Nubank',
  '341 — Itaú',
  '336 — C6 Bank',
  '748 — Sicredi',
  '756 — Sicoob',
]

export const NIVEIS_FORMACAO = [
  'Ensino Fundamental',
  'Ensino Médio',
  'Técnico',
  'Tecnólogo',
  'Ensino Superior',
  'Pós-Graduação',
  'MBA',
  'Mestrado',
  'Doutorado',
]

export const DOCS_LISTA = [
  { id: 'rg', label: 'RG / Identidade', req: true },
  { id: 'cpf', label: 'CPF', req: true },
  { id: 'ctps', label: 'Carteira de Trabalho (CTPS)', req: true },
  { id: 'pis', label: 'PIS / PASEP', req: true },
  { id: 'comp_res', label: 'Comprovante de Residência', req: true },
  { id: 'foto_3x4', label: 'Foto 3×4 recente', req: true },
  { id: 'cert_nasc', label: 'Certidão de Nascimento/Casamento', req: false },
  { id: 'escolaridade', label: 'Comprovante de Escolaridade', req: false },
  { id: 'cnh', label: 'CNH', req: false },
  { id: 'cert_mil', label: 'Certidão Militar', req: false },
  { id: 'atestado_adm', label: 'Atestado Médico Admissional', req: false },
  { id: 'outros', label: 'Outros documentos', req: false },
] as const

export const BENEFICIOS_OPTS = [
  { id: 'vt', label: 'Vale-transporte' },
  { id: 'va', label: 'Vale-alimentação' },
  { id: 'vr', label: 'Vale-refeição' },
  { id: 'plano_saude', label: 'Plano de saúde' },
  { id: 'plano_odonto', label: 'Plano odontológico' },
  { id: 'seguro_vida', label: 'Seguro de vida' },
  { id: 'gympass', label: 'Wellhub / Gympass' },
] as const

export const STATUS_ADMISSAO = [
  { id: '', label: 'Todos os status' },
  { id: 'iniciada', label: 'Iniciada' },
  { id: 'doc_pendente', label: 'Doc. pendente' },
  { id: 'doc_completa', label: 'Doc. completa' },
  { id: 'integrado', label: 'Integrado' },
  { id: 'concluida', label: 'Concluída' },
]
